import * as v from 'valibot'

export const useValibot = () => v
